import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import InstagramDetail from "./instagram-detail";

const InstagramDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/instagrams');
    }

    return (
        <InstagramDetail id={id} onClose={onClose}/>
    )

});

export default InstagramDetailPage;